import * as React from "react";
const SvgAuto = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props
  },
  /* @__PURE__ */ React.createElement("g", { id: "streamline:ai-redo-spark" }, /* @__PURE__ */ React.createElement("g", { id: "Group" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector",
      d: "M4.61603 17.0011V14.3093H7.30776",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_2",
      d: "M16.8802 8.71668C17.1658 10.2405 16.9374 11.816 16.2309 13.196C15.5243 14.576 14.3796 15.6824 12.9764 16.3415C11.5731 17.0007 9.99075 17.1753 8.47753 16.838C6.96432 16.5007 5.6059 15.6706 4.61545 14.4779M3.1198 11.289C2.8342 9.7652 3.06259 8.18968 3.76913 6.80969C4.47567 5.42969 5.62038 4.32331 7.02362 3.66415C8.42687 3.005 10.0093 2.83037 11.5225 3.16768C13.0357 3.50498 14.3941 4.33512 15.3846 5.52784",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  ), /* @__PURE__ */ React.createElement(
    "path",
    {
      id: "Vector_3",
      d: "M15.3842 3.00464V5.69637H12.6924M6.84224 10.3657C6.46128 10.2995 6.46128 9.75242 6.84224 9.68622C7.51656 9.56827 8.14057 9.25247 8.63495 8.77897C9.12932 8.30546 9.47173 7.69565 9.61864 7.02704L9.64143 6.92176C9.72392 6.54514 10.2601 6.54297 10.3458 6.91851L10.3741 7.04115C10.5257 7.70717 10.8709 8.31346 11.3663 8.78374C11.8616 9.25401 12.4851 9.56726 13.158 9.68405C13.5412 9.75025 13.5412 10.3005 13.158 10.3678C12.4852 10.4845 11.8619 10.7976 11.3665 11.2677C10.8711 11.7378 10.5259 12.3438 10.3741 13.0096L10.3458 13.1312C10.2601 13.5067 9.72392 13.5046 9.64143 13.1279L9.61972 13.0237C9.47267 12.3548 9.12994 11.7448 8.63514 11.2713C8.14035 10.7978 7.51587 10.4821 6.84116 10.3646L6.84224 10.3657Z",
      stroke: "currentColor",
      strokeWidth: 1.5,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )))
);
export default SvgAuto;
